/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import DbBaseObject from "@shared/DbBaseObject.js";
import ClientProfile from "@/core/js/model/Profile/ClientProfile";
import CoachingProgram, {ProgramCategoryEnum} from "@/core/js/model/Program/CoachingProgram";
import {CollectionReference} from "@firebase/app";
import {DocumentReference} from "@firebase/app";
import {Firestore} from "@firebase/app";


import {classToPlain, plainToClass} from "class-transformer";
import {Store} from "vuex";
import UserProfile from "@/core/js/model/Profile/UserProfile";
import {HttpsCallable, HttpsCallableResult} from "@firebase/app";
import ProgramInvite from "@/core/js/model/Program/ProgramInvite";
import {docsToData, docToData} from "@/utils/helpers";
import {RoleEnum} from "@/core/js/model/Permissions/RoleEnum";

import axios from 'axios'
// import EventType, {EventTypeCategory} from "@/core/js/model/scheduler/EventType";
import ScheduledEvent from "@/core/js/model/scheduler/ScheduledEvent";
import QwoachFile from "@shared/Drive/QwoachFile";
import NoteItem from "@/core/js/model/Profile/NoteItem";

import BillingData from "@/core/js/model/Billing/BillingData";
import Pager from "@shared/Pager";
import InvoiceGroup from "@/core/js/model/Invoice/InvoiceGroup";
import OldFunnelItem from "@/core/modules/coach/Clients/Funnel/model/old/OldFunnelItem";
import QwoachDataManager from "@/core/js/backend/QwoachDataManager";
import StorageRef from "@/core/js/backend/FIrebaseWrappers/ref/StorageRef";

const API_CALENDAR_ADD_TO_GOOGLE_URL = "/api/calendar/public/link/google"
const API_CALENDAR_ADD_TO_OTHER_URL = "/api/calendar/public/link/ical"

export default class Server extends DbBaseObject {

	fb = require('@/core/js/backend/firebaseConfig')
	store: Store;
	paths: FbPaths;
	func: FbFunctions;

	dataManager: QwoachDataManager
	baseUrl: string = process.env.VUE_APP_DOMAIN


	constructor(store: Store) {
		super();
		console.log("Server.fb = ", this.fb)
		console.warn("Server is deprecated. Use QwoachDataManager instead")
		this.store = store;
		this.paths = new FbPaths(this.fb)
		this.fbStorage = new FbStorage(this.fb)
		this.func = new FbFunctions(this.fb)
		this.serverInit();
	}

	generateDocId() {
		return this.paths.getDb().collection("idGen").doc().id;
	}

	serverInit() {
		this.setupAxiosDebug();
		// this.startListenForLoginStateChange();
	}



	getAddToGoogleCalendarUrl(){
		return this.getAbsoluteUrl(API_CALENDAR_ADD_TO_GOOGLE_URL)
	}

	getAddToOtherCalendarUrl(){
		return this.getAbsoluteUrl(API_CALENDAR_ADD_TO_OTHER_URL)
	}

	getAbsoluteUrl(relativeUrl){
		return this.baseUrl + relativeUrl;
	}

	post(url, data, forceRefresh) {
		return this.postAbsolute(this.getAbsoluteUrl(url), data, forceRefresh)
	}
	get(url, data, forceRefresh) {
		return this.getAbsolute(this.getAbsoluteUrl(url), data, forceRefresh)
	}
	delete(url, data, forceRefresh) {
		return this.deleteAbsolute(this.getAbsoluteUrl(url), data, forceRefresh)
	}

	postAbsolute(url, data, forceRefresh){
		console.log("server post: url = ", url, ", data = ", data)
		return this.createAuthHeader(forceRefresh)
			.then(headers => axios.post(url, data, {headers: headers}))
			.then(this.responseToData)
	}
	getAbsolute(url, data, forceRefresh){
		console.log("server get: url = ", url, ", data = ", data)
		return this.createAuthHeader(forceRefresh)
			.then(headers => axios.get(url, {headers: headers, params: data}))
			.then(this.responseToData)

	}
	deleteAbsolute(url, data, forceRefresh){
		console.log("server delete: url = ", url, ", data = ", data)
		return this.createAuthHeader(forceRefresh)
			.then(headers => axios.delete(url, {headers: {headers}, data: data, maxContentLength: 10000}))
			.then(this.responseToData)
	}

	responseToData(response){
		return (response.data || {})
	}

	createAuthHeader(forceRefresh = true){
		return this.getUserToken(forceRefresh)
			.then(token => {
				let auth = {'Authorization': 'Bearer ' + token};
				console.log("createAuthHeader: auth = ", auth)
				return auth
			})
			.catch(error => {
				console.error(error)
				return {}
			})

	}

	getUserToken(forceRefresh) {
		return Promise.resolve()
			.then(() => this.fb.auth.currentUser.getIdToken(forceRefresh))
	}


	// createClientAndSendInvite(clientsToSendInviteTo: ClientProfile, programInfo: ProgramInfo): Promise<void> {
	// 	return this.createClients([clientsToSendInviteTo])
	// 		.then(() => {
	// 			console.log("createClientsAndSendInvites: clients created");
	// 			return this.sendInvites(programInfo)
	// 		})
	//
	// }




	sendInvite(programInvite: ProgramInvite): Promise<void> {
		return this.func.sendInvite(programInvite);
	}

	schedulerCreateEventType(eventType){
		let coachProfile = this.getCoachProfileStore()
		console.log("schedulerCreateEventType: coachProfile = ", coachProfile)
		eventType.coachId = coachProfile.id
		eventType.coachName = coachProfile.name
		eventType.coachEmail = coachProfile.email
		eventType.coachPictureUrl = coachProfile.pictureUrl
		eventType.coachTz = coachProfile.schedulerSettings.timeZone

		return this.addDocument(eventType, this.paths.eventTypesRef())
	}


	schedulerGetEventById(eventId: string){
		return this.paths.eventsRef()
			.doc(eventId)
			.get()
			.then(doc => {
				return plainToClass(ScheduledEvent, doc.data())
			})
	}

	findScheduledSessionsByOwnerId(ownerId){
		console.log("findScheduledSessionsByOwnerId: ownerId = ", ownerId)
		return this.paths.eventsRef()
			.orderBy('createdAt', 'asc')
			.where('ownerIds', 'array-contains', `${ownerId}`)
			.get()
			.then(res => {
				let list = res.docs.map(doc => plainToClass(ScheduledEvent, doc.data()));
				list = this.applyAvailability(list)
				console.log("findScheduledSessionsByOwnerId: list = ", list)
				return list;
			})
	}


	// findSessionTypeByOwnerId(ownerId, category = EventTypeCategory.PROGRAM){
	// 	return this.paths.eventTypesRef()
	// 		.orderBy('createdAt', 'asc')
	// 		.where('ownerIds', 'array-contains', `${ownerId}`)
	// 		.where('category', '==', `${category}`)
	// 		.get()
	// 		.then(res => {
	// 			let list = res.docs.map(doc => plainToClass(EventType, doc.data()));
	// 			console.log("findSessionTypeByOwnerId: list = ", list)
	// 			return list;
	// 		})
	// }

	schedulerListNotCompletedEventsPast(count){
		console.log("schedulerListConfirmedEvents: this.currentUserId() = ", this.currentUserId())
		return this.paths.eventsRef()
			.orderBy('startTime', 'desc')
			.where('startTime', '<', new Date().getTime())
			.where('coachId', '==', `${this.currentUserId()}`)
			.where('isCompleted', '==', false)
			.limit(count || 20)
			.get()
			.then(res => {
				let list = res.docs.map(doc => plainToClass(ScheduledEvent, doc.data()));
				return list;
			})
	}


	//this method is to create the event with admin rights (lightweight)
	schedulerEventConfirm(event: ScheduledEvent){
		return this.post("/api/calendar/public/eventConfirm", {event: classToPlain(event)})
	}
	createOrUpdateEvent(event: ScheduledEvent): Promise<CollectionReference> {
		return this.addDocument(event, this.paths.eventsRef());
	}
	updateEvent(event: ScheduledEvent): Promise<CollectionReference> {
		return this.updateDocument(event, this.paths.eventsRef());
	}

	//this method is to add the event to the calendar and send notification emails (time consuming)
	schedulerNotifyEventConfirmed(event: ScheduledEvent){
		console.log("schedulerNotifyEventConfirmed: event = ", event)
		return this.post("/api/calendar/public/event/notify", {event: classToPlain(event)})
	}
	// schedulerNotifyEventUpdated(event: ScheduledEvent){
	// 	console.log("schedulerNotifyEventUpdated: event = ", event)
	// 	return this.post("/api/calendar/public/eventUpdated", {event: classToPlain(event)})
	// 		.then(event => plainToClass(ScheduledEvent, event))
	//
	// }

	// logError(error, info){
	// 	let currentUser = this.getCurrentUser() || {}
	// 	let data = {
	// 		stack: error.stack,
	// 		error: error,
	// 		info: info,
	// 		userEmail: currentUser.email,
	// 		userId: currentUser.uid,
	// 	}
	// 	return this.post("/api/utils/logError", data)
	// }


	schedulerEventCancel(event: ScheduledEvent){
		return this.updateDocument(event, this.paths.eventsRef())
	}

	// schedulerEventDelete(event: ScheduledEvent){
	// 	return this.deleteDocument(event, this.paths.eventsRef())
	// }

	schedulerUpdateEventType(eventType){
		return this.updateDocument(eventType, this.paths.eventTypesRef())
	}

	createProgramInvite(programInvite: ProgramInvite) {
		return this.addDocument(programInvite, this.paths.programInvitesRef())
	}
	deleteProgramInvite(programInvite: ProgramInvite) {
		return this.deleteDocument(programInvite, this.paths.programInvitesRef())
	}


	createClientProfile(clientProfile: ClientProfile) {
		return this.addDocument(clientProfile, this.paths.clientsRef())
	}

	updateClientProfile(userProfile: UserProfile): Promise<void> {
		return this.addDocument(userProfile, this.paths.usersRef())
	}
	deleteClientProfile(userProfile: UserProfile): Promise<void> {
		return this.deleteDocument(userProfile, this.paths.usersRef())
	}


	createProgram(programItem: CoachingProgram) {
		return this.addDocument(programItem, this.paths.programsRef())
	}

	getClientList(): Promise<ClientProfile[]> {
		console.log('getClientList')
		// doc(state.currentUser.uid)
		return new Promise((resolve, reject) => {
			this.paths.clientsRef()
			// .where('coachIds', 'array-contains', `${this.currentUserId()}`)
				.orderBy('createdAt', 'desc')
				// .limit(2)
				// .get()
				.onSnapshot(res => {
					console.log('getClientList: res = ', res)
					let programList = res.docs.map(doc => plainToClass(ClientProfile, doc.data()));
					console.log('getClientList: clientList = ', programList)
					this.store.commit('setClientList', programList)
					resolve(programList);
				}, error => {
					reject(error);
				})
		});
	}

	getNoteList(ownerId: string): Promise<NoteItem[]> {
		console.log('getNoteList')
		// doc(state.currentUser.uid)
		return new Promise((resolve, reject) => {
			this.paths.notesRef()
				.where('ownerIds', 'array-contains', `${ownerId}`)
				.orderBy('createdAt', 'desc')
				.onSnapshot(res => {
					console.log('getNoteList: res = ', res)
					let list = res.docs.map(doc => plainToClass(NoteItem, doc.data()));
					console.log('getNoteList: list = ', list, ", ownerId = ", ownerId)
					this.store.commit('setNotes', {id: ownerId, data: list})
					resolve(list);
				}, error => {
					reject(error);
				})
		});
	}

	deleteNote(note: NoteItem): Promise<NoteItem> {
		console.log('deleteNote')
		return this.deleteDocument(note, this.paths.notesRef())
	}
	updateNote(note: NoteItem): Promise<NoteItem> {
		console.log('updateNote')
		return this.updateDocument(note, this.paths.notesRef())
	}

	createNote(ownerId: [], note: NoteItem): Promise<NoteItem> {
		console.log('createNote')
		if(!Array.isArray(ownerId)){
			ownerId = [ownerId]
		}
		note.ownerIds.push(...ownerId)
		return this.addDocument(note, this.paths.notesRef())
	}
	getCoachingProcessList(): Promise<CoachingProgram[]> {
		return this.getProgramList(ProgramCategoryEnum.PROCESS, 'setProgramList')
	}

	getProgramTemplateList(): Promise<CoachingProgram[]> {
		return this.getProgramList(ProgramCategoryEnum.TEMPLATE, 'setProgramTemplateList')
	}

	getProgramList(programCategory, storeSetter): Promise<CoachingProgram[]> {
		let uid = this.currentUserId();
		let ref = this.paths.programsRef()
		if(this.isCurrentUserClient()){
			ref = this.paths.programsGroupRef()
				.where('clientIdArray', 'array-contains', `${uid}`)
		}
		console.log('getCoachingProcessList: uid = ', uid)
		// console.log('getCoachingProcessList: params = ', params)
		console.log('getCoachingProcessList: this.isCurrentUserClient() = ', this.isCurrentUserClient())
		// doc(state.currentUser.uid)
		return new Promise((resolve, reject) => {
			ref
				.orderBy('createdAt', 'desc')
				.where('programCategory', '==', programCategory)
				// .limit(2)
				// .get()
				.onSnapshot(res => {
					console.log('fetchProgramList: res = ', res)
					let userProfile = this.getCurrentUser();
					let array = res.docs.map(doc => {
						let program = plainToClass(CoachingProgram, doc.data())
						program
						return program;
					});
					if(this.isCurrentUserClient()){
						array = array.filter(program => program.isClientEnabled)
					}

					console.log('fetchProgramList: programList = ', array)
					this.store.commit(storeSetter, array)
					resolve(array);
				}, error => {
					reject(error);
				})
		});
	}

	getClientByEmail(email : string): Promise<?ClientProfile> {
		console.log("getClientByEmail: email = ", email)
		return this.paths.clientsRef()
			.where('email', '==', `${email}`)
			.get()
			.then(res => {
				let userProfile = res.docs.map(doc => plainToClass(ClientProfile, doc.data()))[0];
				return userProfile;
			})
	}





	acceptInvite(programInvite: ProgramInvite): Promise<HttpsCallableResult>{
		return this.func.acceptInvite(programInvite)
	}

	getProgramInvite(coachId: string, inviteId: string): Promise<ProgramInvite> {
		console.log('getProgramInvite: inviteId = ', inviteId, ", coachId = ", coachId)
		return this.paths.programInvitesRef(coachId)
			.doc(inviteId)
				.get()
				.then(res => {
					console.log('getProgramInfo: res = ', res)
					let data = plainToClass(ProgramInvite, res.data());
					console.log('getProgramInfo: list = ', data)

					if(data){
						return data
					} else {
						throw Error("no invite object")
					}
				})

	}

	getProgramById(programId: string, coachId: string = this.getCoachId(), onProgramChangedListener): Promise<CoachingProgram> {

		console.log('getProgramById: programId = ', programId)
		return new Promise((resolve, reject) => {
			this.paths.programsRef(coachId)
				.doc(programId)
				.onSnapshot(res => {
					console.log('getProgramById: res = ', res)
					let programItem = plainToClass(CoachingProgram, res.data())
					console.log('getProgramById: programItem = ', programItem)
					this.store.commit('setProgramDetailsItem', programItem)
					if(onProgramChangedListener) onProgramChangedListener(programItem)
					resolve(programItem);
				}, error => {
					reject(error);
				})
		})
	}



	getBillingDataById(billingDataId: string): Promise<BillingData> {
		console.log('getBillingDataById: programId = ', billingDataId)
		return this.paths.billingDataRef()
			.doc(billingDataId)
			.get()
			.then(res => docToData(res, BillingData))
	}

	getInvoiceGroupById(invoiceGroupId: string): Promise<InvoiceGroup> {
		console.log('getInvoicesById: invoiceGroupId = ', invoiceGroupId)
		return this.paths.invoicesRef()
			.doc(invoiceGroupId)
			.get()
			.then(res => docToData(res, InvoiceGroup))
	}
	filterInvoices(limit: number = 20): Pager {
		let ref = this.paths.invoicesRef()
			.orderBy("createdAt", "desc")
		return new Pager(ref, InvoiceGroup, limit)
	}



	updateInvoiceGroup(invoiceGroup: InvoiceGroup): Promise<InvoiceGroup> {
		console.log("updateInvoice: invoiceGroup = ", invoiceGroup)
		return this.updateDocument(invoiceGroup, this.paths.invoicesRef())
	}
	deleteInvoiceGroup(invoiceGroup: InvoiceGroup): Promise<InvoiceGroup> {
		console.log("deleteInvoice: invoiceGroup = ", invoiceGroup)
		return this.deleteDocument(invoiceGroup, this.paths.invoicesRef())
	}



	getFunnel(): Promise<OldFunnelItem> {
		return this.paths.funnelsRef()
			.limit(1)
			.get()
			.then(res => docsToData(res, OldFunnelItem))
	}
	updateFunnel(funnel: OldFunnelItem): Promise<OldFunnelItem> {
		return this.updateDocument(funnel, this.paths.funnelsRef())
	}
	deleteFunnel(funnel: OldFunnelItem): Promise<OldFunnelItem> {
		return this.deleteDocument(funnel, this.paths.funnelsRef())
	}





	sendPasswordResetEmail(email: string):Promise<void>{
		return this.fb.auth.sendPasswordResetEmail(email)
	}

	signInWithEmailAndPassword(email: string, password: string): Promise<UserProfile> {
		console.log("signInWithEmailAndPassword: email = ", ", password = ", password)
		return this.fb.auth.signInWithEmailAndPassword(email, password)
			.then(response => {
				console.log("signInWithEmailAndPassword: response = ", response)
				this.store.commit('setCurrentUser', response.user)
				return this.getCurrentUserProfile();
			})
	}
	isUserExist(email: string): Promise<boolean> {
		return this.fb.auth.fetchSignInMethodsForEmail(email)
			.then(response => {
				console.log("isUserExists: response = ", response)
				return (response || []).length > 0;
			}).catch(error => {
				console.error("isUserExists: error = ", error)
				return false;
			})
	}




	createUserWithEmailAndPassword(password: string, userProfile: UserProfile): Promise<void> {
		console.log("createUserWithEmailAndPassword: userProfile = ", userProfile)
		return this.fb.auth.createUserWithEmailAndPassword(userProfile.email, password)
			.then(response => {
				let user = response.user
				userProfile.id = user.uid
				this.store.commit('setCurrentUser', user)
				console.log("createUserWithEmailAndPassword: userProfile = ", userProfile)
				return this.createUserProfile(userProfile);
			}).then(() => {
				return this.getCurrentUserProfile();
			});
	}


	createUserProfile(userProfile: UserProfile): Promise<void> {
		return this.addDocument(userProfile, this.paths.usersRef())
	}
	// updateUserProfile(userProfile: UserProfile): Promise<void> {
	// 	return this.addDocument(userProfile, this.paths.usersRef())
	// }
	deleteUserProfile(userProfile: UserProfile): Promise<void> {
		return this.deleteDocument(userProfile, this.paths.usersRef())
	}

	getCurrentUser() {
		return this.store.state.store.currentUser;
	}
	getCoachProfileStore() {
		return this.store.state.store.coachProfile;
	}
	getCurrentUserProfileStore() {
		return this.store.state.store.userProfile;
	}

	getCoachId(){
		return this.getCurrentUserProfileStore().getCoachId()
	}

		getCurrentUserProfile(): Promise<UserProfile> {
		let userProfile;
		console.log("getCurrentUserProfile start")
		let uid = this.getCurrentUser().uid;
		console.log("getCurrentUserProfile: uid = ", uid)

		let ref = this.dataManager.getUserProfile(uid)

		console.log("getCurrentUserProfile: this.dataManager = ", this.dataManager)
		console.log("getCurrentUserProfile: ref = ", ref)
		// this.dataManager
		return ref.then(userProfileLocal => {
				console.log("getCurrentUserProfile: userProfile = ", userProfile)
				userProfile = userProfileLocal//plainToClass(UserProfile, res.data());
				let coachId = userProfile.getCoachId()
				console.log("getCurrentUserProfile: userProfile = ", userProfile)
				console.log("getCurrentUserProfile: userProfile.getCoachId() = ", coachId)
				this.fbStorage.coachId = coachId
				this.paths.coachId = coachId
				console.log("getCurrentUserProfile: userProfile = ", userProfile)
				this.store.commit('setUserProfile', userProfile)
				return this.setCoachProfile()
					.then(_ => userProfile)
			})
			.catch(err => {
				console.log("getCurrentUserProfile: err = ", err)
			})
	}
	setCoachProfile(){
		let promise = Promise.resolve(this.getCurrentUserProfileStore());
		if(this.isCurrentUserCoach()){
			this.store.commit('setCoachProfile', this.getCurrentUserProfileStore())
		} else {
			promise = this.paths.userRef(this.getCoachId())
				.get()
				.then(res => {
					let coachProfile = plainToClass(UserProfile, res.data());
					this.store.commit('setCoachProfile', coachProfile)
					return coachProfile;
				})
		}
		return promise;
	}

	updateUserProfile(userProfile:UserProfile): Promise<UserProfile> {
		return this.updateDocument(userProfile, this.paths.usersRef())
			.then(() => {
				this.store.commit('setUserProfile', userProfile)
				return this.setCoachProfile()
			});
	}


	logout() {
		return this.fb.auth.signOut().then(() => {
			this.store.dispatch('clearData')
		})
	}

	assignIdIfNeeded(object: DbBaseObject){
		let fbCollection = this.paths.usersRef()
		object.assignId(fbCollection);
	}


	addDocument(object: DbBaseObject, fbCollection: CollectionReference): Promise<CollectionReference> {
		object.assignId(fbCollection);
		let docRef = fbCollection.doc(object.id);
		let objJson = object.asDbJson();
		console.log("addDocument: object = ", object)
		console.log("addDocument: objJson = ", objJson)
		return docRef.set(objJson, {merge: true})
			.then(() => object)
	}

	updateDocument(object: DbBaseObject, fbCollection: CollectionReference): Promise<CollectionReference> {
		object.assignId(fbCollection);
		let docRef = fbCollection.doc(object.id);
		let objJson = object.asDbJson();
		console.log("updateDocument: object = ", object)
		console.log("updateDocument: objJson = ", objJson)
		console.log("updateDocument: docRef = ", docRef)
		return docRef.set(objJson, {merge: true})
			.then(() => object)
	}

	deleteDocument(object: DbBaseObject, fbCollection: CollectionReference): Promise<CollectionReference> {
		let docRef = fbCollection.doc(object.id);
		console.log("deleteDocument: object = ", object)
		return docRef.delete()
			.then(() => object)
	}



	startListenForLoginStateChange(callback) {
		this.fb.auth.onAuthStateChanged(user => {
			console.log("onAuthStateChanged: user1 = ", user)
			if (user) {
				this.store.commit('setCurrentUser', user)
				this.getCurrentUserProfile()
					.then(userProfile => {
						console.log("onAuthStateChanged: userProfile = ", userProfile)
						if(callback) {callback(userProfile)}
					})
					.catch(error => {
						console.error("onAuthStateChanged: error = ", error)
						if(callback) {callback(null, error)}
					})
				console.log("onAuthStateChanged: user2 = ", user)

			} else {
				this.store.commit('setCurrentUser', null)
				if(callback) {callback(null)}
			}
		}, error =>{
			console.error("onAuthStateChanged: error = ", error)
			if(callback) {callback(null, error)}
		})
	}

	currentUserRole(){
		return (this.getCurrentUserProfileStore() || {}).role;
	}
	isCurrentUserCoach(){
		return this.currentUserRole() == RoleEnum.COACH;
	}
	isCurrentUserClient(){
		return this.currentUserRole() == RoleEnum.CLIENT;
	}
	currentUserId() {
		return this.paths.currentUserId();
	}


	setupAxiosDebug() {
		if(process.env.NODE_ENV == "development"){
			axios.interceptors.request.use(request => {
				console.log('Starting Request', request)
				return request
			})

			axios.interceptors.response.use(response => {
				console.log('Response:', response)
				return response
			})
		}
	}
}


class FbPaths {

	fb;
	coachId

	constructor(fb) {
		this.fb = fb;
	}

	getCurrentUser() {
		return this.fb.auth.currentUser;

	}

	currentUserId() {
		return this.getCurrentUser().uid;
	}

	currentUserProfileRef(): DocumentReference {
		let uid = this.getCurrentUser().uid;
		console.log("currentUserProfileRef: uid = ", uid)
		return this.userRef(uid);
	}
	userRef(userId): CollectionReference {
		return this.usersRef().doc(userId);
	}

	usersRef(): CollectionReference {
		return this.getRef('users');
	}


	programsRef(coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/programs`);
	}

	programsGroupRef(): CollectionReference {
		return this.getDb().collectionGroup('programs');
	}

	programInvitesRef(coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/programInvites`);
	}

	clientsRef(coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/clients`);
	}

	billingDataRef(coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/billingData`);
	}
	invoicesRef(coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/invoices`);
	}
	funnelsRef(coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/funnels`);
	}
	funnelByIdRef(funnelId: string, coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/funnels/${funnelId}`);
	}


	eventTypesRef(coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/eventTypes`);
	}

	notesRef(coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/notes`);
	}


	eventsRef(coachId: string = this.coachId): CollectionReference {
		return this.getRef(`users/${coachId}/events`);
	}

	// getRef(path: string, ref: ?CollectionReference, startWithCollectionRef: boolean = true) {
	// 	let split = path.split("/");
	// 	console.log("getRef: path = ", path, ", split = ", split);
	// 	ref = ref || this.getDb();
	// 	let oddity = startWithCollectionRef ? 0 : 1;
	// 	for (let i = 0; i < split.length; ++i) {
	// 		let pathSegment = split[i];
	// 		if (i % 2 === oddity) {
	// 			ref = ref.collection(pathSegment);
	// 			// console.log("getRef: pathSegment = ", pathSegment, ", added as a collection");
	// 		} else {
	// 			ref = ref.doc(pathSegment);
	// 			// console.log("getRef: pathSegment = ", pathSegment, ", added as a document");
	// 		}
	// 	}
	// 	return ref;
	// }

	getRef(path, ref) {
		let split = path.split("/");
		ref = ref || this.getDb();
		if (split.length % 2 === 0) {
			ref = ref.doc(path);
		} else {
			ref = ref.collection(path);
		}
		return ref;
	}

	getDb(): Firestore {
		return this.fb.firestore
	}
}

class FbStorage {

	storageRef;
	coachId

	constructor(fb){
		this.storageRef = fb.storage.ref()
	}

	coachFolder(){
		return this.storageRef.child("users").child(this.coachId)
	}

	pathToRef(path: string){
		return this.storageRef.child(path)
	}


	taskAttachmentsFile(programId, taskId, ownerId, fileName){
		return this.taskAttachmentsFolder(programId, taskId, ownerId).child(fileName)
	}
	// taskCoachAttachmentsFile(taskId, fileName){
	// 	return this.taskCoachAttachmentsFolder(taskId).child(fileName)
	// }
	// taskClientAttachmentsFile(taskId, clientId, fileName){
	// 	return this.taskClientAttachmentsFolder(taskId).child(fileName)
	// }

	taskAttachmentsFolder(programId, taskId, ownerId){
		let ref = this.coachFolder().child("program").child(programId).child("task").child(taskId).child("fileOwner").child(ownerId);
		console.log("taskAttachmentsFolder: path = ", ref)
		return ref
	}

	// taskCoachAttachmentsFolder(taskId){
	// 	return this.coachFolder().child("task").child("attachments").child(taskId).child("coach");
	// }
	// taskClientAttachmentsFolder(taskId, clientId){
	// 	return this.coachFolder().child("task").child("attachments").child(taskId).child("client").child(clientId);
	// }
	taskAttachmentsDelete(programId, taskId, ownerId, fileName){
		let fileRef = this.taskAttachmentsFile(programId, taskId, ownerId, fileName)
		return this.deleteFile(fileRef)
	}

	taskAttachmentsListAll(programId, taskId, ownerId){
		if(programId && taskId){
			let folderRef = this.taskAttachmentsFolder(programId, taskId, ownerId);
			console.log("taskAttachmentsListAll: programId = ", programId, ", taskId = ", taskId, ", ownerId = ", ownerId)
			return this.taskAttachmentsListAllInternal(folderRef)
		}
		return []
	}
	// taskClientAttachmentsListAll(taskId, clientId){
	// 	let folderRef = this.taskClientAttachmentsFolder(taskId, clientId);
	// 	return this.taskAttachmentsListAll(folderRef)
	// }

	taskAttachmentsListAllInternal(ref){
		return ref
			.listAll()
			.then(res => {
				console.log("taskCoachAttachmentsListAll: res = ", res)
				let resList = []
				res.items.forEach(fileRef => {
					let fileWrapperPromise = fileRef.getDownloadURL()
						.then(url => {
							return new QwoachFile(fileRef.name, fileRef.fullPath, url, fileRef)
						})
					resList.push(fileWrapperPromise)
				})
				return Promise.all(resList)
			})
	}

	uploadTaskAttachment(programId, taskId, ownerId, fileName, file, progress){
		console.log("uploadTaskAttachment: ownerId = ", ownerId)
		let folderRef = this.taskAttachmentsFolder(programId, taskId, ownerId)
		return this.uploadFile(folderRef, fileName, file, progress)
	}
	deleteTaskAttachment(filePath){
		let fileRef = this.pathToRef(filePath)
		return this.deleteFile(fileRef)
	}
	deleteFileByPath(filePath){
		let fileRef = this.pathToRef(filePath)
		return this.deleteFile(fileRef)
	}

	uploadFile(storageRef, fileName, file, progressCallback){
		return new Promise((resolve, reject) => {
			var uploadRef = storageRef.child(fileName)
			let uploadTask = uploadRef.put(file)
			let totalSizeInBytes = -1
			uploadTask.on('state_changed', function(snapshot){
				let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				totalSizeInBytes = snapshot.totalBytes
				// firebase.storage.TaskState.PAUSED:
				// firebase.storage.TaskState.RUNNING:
				if(progressCallback){
					progressCallback(progress, snapshot.state, uploadTask)
				}
			}, function(error) {
				reject(error)
			}, function() {
				new StorageRef(uploadTask.snapshot.ref).getDownloadURL().then(function(downloadURL) {
					console.log('File available at', downloadURL);
					resolve(new QwoachFile(uploadRef.name, uploadRef.fullPath, downloadURL))
				});
			});
		})
	}

	deleteFile(fileRef){
		return fileRef.delete()
	}




}

class FbFunctions {

	fb;

	constructor(fb) {
		this.fb = fb;
	}

	sendInvite(programInvite: ProgramInvite): Promise<HttpsCallableResult> {
		return this.httpsCall("emailSendProgramInvite", programInvite)
	}

	acceptInvite(programInvite: ProgramInvite): Promise<HttpsCallableResult> {
		return this.httpsCall("acceptInvite", programInvite)
	}




	httpsCall(functionName: string, data: any): Promise<HttpsCallableResult> {
		console.log("httpsCall: functionName = ", functionName, ", data = ", data)
		return this.httpsCallable(functionName)(data)
			.then(response => {
				console.log("httpsCall: response = ", response)
				return response;
			}).catch(error => {
				console.error("httpsCall: error = ", error)
				throw error;
			});
	}

	httpsCallable(functionName: string): HttpsCallable {
		return this.fb.functions.httpsCallable(functionName);
	}


}
